// extracted by mini-css-extract-plugin
export var container = "_5y-0";
export var containerTopRight = "_5y-1";